import { getCurrentLocaleCode } from "@mongez/localization";
import { Link, LinkProps } from "@remix-run/react";
import { cn } from "core/shared";

export function PrimaryLink({ to, children, className, ...props }: LinkProps) {
  const localeCode = getCurrentLocaleCode();
  const localizedURL = `/${localeCode}${to}`;

  return (
    <Link
      to={localizedURL}
      {...props}
      className={cn(
        "bg-primary-light hover:bg-primary-500 flex items-center justify-center gap-2 rounded-full border px-8 py-3 text-xs font-medium text-black transition-colors duration-300 sm:text-sm lg:px-12 lg:py-4 lg:text-base",
        className,
      )}
    >
      {children}
    </Link>
  );
}

export function BaseLink({ to, children, ...props }: LinkProps) {
  const localeCode = getCurrentLocaleCode();
  const localizedURL = `/${localeCode}${to}`;

  return (
    <Link to={localizedURL} {...props}>
      {children}
    </Link>
  );
}
